import './notes-list.scss';

import React, { ChangeEvent, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { ROUTES } from '../../App.routes';

const initialRoutes = ROUTES.filter((route) => route.title);

export function NotesList() {
  const [routes, setRoutes] = useState(initialRoutes);
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    const searched = initialRoutes.filter((route) => {
      return (
        route.title?.includes(searchText) || route.path.includes(searchText)
      );
    });
    setRoutes(searched);
  }, [searchText]);

  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  return (
    <nav className="notes-list">
      <span className="notes-list_title">Notes:</span>
      <input
        className="notes-list_search"
        type="text"
        name="search"
        placeholder="Search:"
        value={searchText}
        onChange={handleSearchChange}
      />
      <ul className="notes-list_list">
        {routes.map((route, idx) => (
          <li key={idx}>
            <Link to={route.path}>{route.title}</Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
